export default "__VITE_ASSET__BNC9N0ye__"